import { db } from "@/utils/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateProfile = async (userId, updatedData) => {
  try {
    // Reference to the specific user document
    const userDocRef = doc(db, "users", userId);

    // Update the user document with the provided data
    await updateDoc(userDocRef, {
      first_name: updatedData.firstName || "",
      last_name: updatedData.lastName || "",
      phone: updatedData.phoneNumber || "",
      company: updatedData.companyName || "",
      website: updatedData.website || "",
      agent: updatedData.agent || "",
      country: updatedData.country || "",
      notification: updatedData.notificationPreference || "",
    });

    console.log("User data updated successfully.");
  } catch (error) {
    console.error("Error updating user data:", error.message);
    throw new Error("Failed to update user data. Please try again later.");
  }
};

export default updateProfile;
